(function () {
  if (customElements.get('alva-cart-dispatch')) return;
  customElements.define('alva-cart-dispatch', class extends HTMLElement {
    connectedCallback() {
      if (this.unsubscribe || !window.AlvaShipping) return;
      this.unsubscribe = window.AlvaShipping.subscribe(result => {
        const text = result.order+' · Est. delivery '+result.eta;
        this.querySelectorAll('[data-dispatch-full],[data-dispatch-compact]').forEach(node => {if(node.textContent !== text)node.textContent=text;});
        if(this.getAttribute('aria-label') !== text)this.setAttribute('aria-label',text);
      });
    }
    disconnectedCallback() {if(this.unsubscribe)this.unsubscribe();this.unsubscribe=null;}
  });
})();
